export type SearchFilterCardPreviewFooterMode =
	| 'none'
	| 'create-add-card'
	| 'edit-save';

export const SEARCH_FILTER_DEFAULT_SEARCH_LABEL = 'Search';
export const SEARCH_FILTER_DEFAULT_PLACEHOLDER = 'Type something here...';

/** AppSync wire: search label → `CardItem.title`, placeholder → `CardItem.subtitle`. */
export function resolveSearchFilterLabel(config: {
	title?: string;
	data?: { searchLabel?: string };
}): string {
	return (
		config.title?.trim() ||
		config.data?.searchLabel?.trim() ||
		SEARCH_FILTER_DEFAULT_SEARCH_LABEL
	);
}

/** AppSync wire: search placeholder → `CardItem.subtitle`. */
export function resolveSearchFilterPlaceholder(config: {
	subtitle?: string;
	data?: { placeholder?: string };
}): string {
	return (
		config.subtitle?.trim() ||
		config.data?.placeholder?.trim() ||
		SEARCH_FILTER_DEFAULT_PLACEHOLDER
	);
}

/** Removes legacy `data.searchLabel` / `data.placeholder` before `updateCard`. */
export function omitLegacySearchFilterDataFields<
	T extends { searchLabel?: string; placeholder?: string },
>(data: T): Omit<T, 'searchLabel' | 'placeholder'> {
	const { searchLabel: _label, placeholder: _placeholder, ...rest } = data;
	return rest;
}
